<!--
 * @Author: Gaho
 * @Date: 2024-03-01 11:42:44
 * @LastEditors: Gaho
 * @LastEditTime: 2025-01-21 17:12:10
 * @Description: 
-->
<template>
    <div class="rules-paytable">
        <div class="paytable-row">
            <div 
                class="paytable-col" 
                v-for="(item, index) in payTableData" 
                :key="index"
                :class="index === 0 || index === payTableData.length - 1 ? 'paytable-col-lg' : 'paytable-col-sm'"
            >
                <!-- 图片 -->
                <q-img 
                    v-for="(img, i) in item.imgs" 
                    :src="img" 
                    alt="" 
                    :key="i" 
                    class="col-img"
                    :class="{ 'col-img-md': index === payTableData.length - 1 }"
                />
                <!-- 最后一个col -->
                <div class="col-mutil-desc" v-if="index === payTableData.length - 1">
                    <p class="col-desc mb-[10px]">
                        <span>
                            {{ $t(item?.description?.prev) }}
                        </span>
                    </p>
                    <p class="col-mutil-item" v-for="(ele, ind) in item.mutil" :key="ind">
                        <span class="mutil-item-key">{{ typeof ele.key === 'number' ? ele.key : $t(ele.key) }}:</span>
                        <span class="mutil-item-label" v-if="ele.valueLabel">{{ $t(ele.valueLabel) }} </span>
                        <span class="mutil-item-value"> x{{ ele.value }}</span>
                    </p>
                </div>
                <!-- 倍数 -->
                <div class="col-mutil" v-else>
                    <p class="col-mutil-item" v-for="(ele, ind) in item.mutil" :key="ind">
                        <span class="mutil-item-key">{{ typeof ele.key === 'number' ? ele.key : $t(ele.key) }}:</span>
                        <span class="mutil-item-label" v-if="ele.valueLabel">{{ $t(ele.valueLabel) }} </span>
                        <span class="mutil-item-value"> x{{ ele.value }}</span>
                    </p>
                </div>
                <!-- 描述 -->
                <div class="col-desc" v-if="item.description && index !== payTableData.length - 1">
                    <span>
                        {{ $t(item.description.prev) }}
                    </span>
                    {{ $t(item.description.text) }}
                </div>
            </div>
        </div>
        <!-- 底部描述 -->
        <p class="paytable-desc">
            {{ $t('corgiwildPayTableRule') }}
        </p>
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
// assets
import wildImg from '@/assets/imgs/casino/corgiwild/wild-rule.webp';
import img7 from '@/assets/imgs/casino/corgiwild/7-rule.webp';
import cherryImg from '@/assets/imgs/casino/corgiwild/cherry-rule.webp';
import singleImg from '@/assets/imgs/casino/corgiwild/single-bar-rule.webp';
import doubleImg from '@/assets/imgs/casino/corgiwild/double-bar-rule.webp';
import tripleImg from '@/assets/imgs/casino/corgiwild/triple-bar-rule.webp';

export default defineComponent({
    name: 'dialogPayTable',
    data(){
        return {
            payTableData: [{
                imgs: [
                    wildImg
                ],
                mutil: [
                    {
                        key: 1,
                        value: 2,
                        valueLabel: 'win'
                    },
                    {
                        key: 2,
                        value: 4,
                        valueLabel: 'win'
                    },
                    {
                        key: 3,
                        value: 1000,
                        valueLabel: ''
                    },
                ],
                description: {
                    prev: 'wild',
                    text: 'corgiwildPayTableDesc1'
                }
            }, {
                imgs: [
                    img7
                ],
                mutil: [
                    {
                        key: 3,
                        value: 80,
                        valueLabel: ''
                    }
                ]
            }, {
                imgs: [
                    tripleImg
                ],
                mutil: [
                    {
                        key: 3,
                        value: 40,
                        valueLabel: ''
                    }
                ]
            }, {
                imgs: [
                    doubleImg
                ],
                mutil: [
                    {
                        key: 3,
                        value: 25,
                        valueLabel: ''
                    }
                ]
            }, {
                imgs: [
                    singleImg
                ],
                mutil: [
                    {
                        key: 3,
                        value: 10,
                        valueLabel: ''
                    }
                ]
            }, {
                imgs: [
                    cherryImg
                ],
                mutil: [
                    {
                        key: 3,
                        value: 10,
                        valueLabel: ''
                    },
                    {
                        key: 'any2',
                        value: 5,
                        valueLabel: ''
                    },
                    {
                        key: 'any1',
                        value: 2,
                        valueLabel: ''
                    },
                ]
            }, {
                imgs: [
                    singleImg,
                    doubleImg,
                    tripleImg
                ],
                mutil: [
                    {
                        key: 'any3',
                        value: 5,
                        valueLabel: ''
                    }
                ],
                description: {
                    prev: 'corgiwildPayTableDesc2',
                    text: ''
                }
            }]
        }
    }
})
</script>
<style lang="scss" scoped>
.rules-paytable {
    margin-top: 16px;
    .paytable-row {
        align-items: center;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .paytable-col {
            align-items: center;
            background: #1c2532;
            border-radius: 10px;
            display: flex;
            margin-bottom: 12px;
            padding: 8px 12px 8px 8px;
            @media (max-width: 576px) {
                &:nth-child(6){
                    width: 100%;
                }
            }

            .col-img {
                height: 64px;
                margin-right: 13px;
                width: 64px;
            }
            .col-img-md {
                min-width: 68px;
                width: 68px;
                margin-right: 10px;
            }
            .col-mutil {
                margin-right: 21px;
            }
            .col-mutil-item {
                font-size: 11px;
                line-height: 16px;
                margin-bottom: 0;
                white-space: nowrap;
                color: #fff;
                font-weight: 600;
                .mutil-item-key {
                    color: #93acd3;
                    margin-right: 3px;
                }
                .mutil-item-label, .mutil-item-value {
                    font-weight: 700;
                }
            }
            .col-desc {
                color: #93acd3;
                font-size: 11px;
                font-weight: 500;
                line-height: 16px;
                max-width: 140px;
                span {
                    color: #fff;
                    font-weight: 600;
                }
            }
        }
        .paytable-col-lg {
            width: calc(67% - 6px);
            @media (max-width: 576px) {
                width: 100%;
            }
        }
        .paytable-col-sm {
            width: calc(33% - 7px);
            @media (max-width: 576px) {
                width: calc(50% - 6px);
            }
        }
    }
    .paytable-desc {
        color: #93acd3;
        font-size: 12px;
        font-weight: 500;
        line-height: 18px;
        margin-bottom: 20px;
    }
}
</style>